module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_mobile_09@2x-eba8f0ea5a825931e87060e8473736be.jpg";